<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766638364292" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6637" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="6638"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="6639" data-spm-anchor-id="a313x.search_index.0.i1.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{bookData.className}}</div>
                <div class="left-head-container">
                </div>
            </div>
            <div class="info-container">
                <div class="info-container-l">
                    <el-scrollbar class="scrollbar-container">
                        <div class="unit-container" v-for="item in unitList" :key="item.classId">
                            <div :class="this.unitId&&this.unitId.includes(item.classId)?'unit-container-title-active':'unit-container-title'"
                                 @click="selUnitItem(item.classId,'',[],1)">
                                {{item.className}}
                            </div>
                            <div class="unit-item-container">
                                <div :class="this.chapterId&&this.chapterId.includes(i.classId)?'unit-item-active':'unit-item'" v-for="i in item.childrenList" :key="i"
                                     @click="selUnitItem(item.classId,i.classId,i.childrenList,2)">
                                    {{i.className}}
                                    <svg t="1761012570279" v-if="this.chapterId&&this.chapterId.includes(i.classId)" @click="handleItem(i.classId, i.className)" style="margin-left: 8px;vertical-align: middle;margin-top: -4px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19178" width="16" height="16"><path d="M882.6 325V135.8c0-39.6-32.2-71.8-71.8-71.8H213.2c-39.6 0-71.8 32.2-71.8 71.8v752.4c0 39.6 32.2 71.8 71.8 71.8h597.5c39.6 0 71.8-32.2 71.8-71.8V699c0-20.7-16.7-37.4-37.4-37.4s-37.4 16.7-37.4 37.4v186.1H416.1V138.8h391.6V325c0 20.7 16.7 37.4 37.4 37.4s37.5-16.8 37.5-37.4zM341.3 885.2h-125V138.8h125.1v746.4z" p-id="19179" fill="#ffffff"></path><path d="M669.6 697.7c20.7 0 37.4-16.7 37.4-37.4V549.4h110.9c20.7 0 37.4-16.7 37.4-37.4s-16.7-37.4-37.4-37.4H707V363.7c0-20.7-16.7-37.4-37.4-37.4s-37.4 16.7-37.4 37.4v110.9H521.3c-20.7 0-37.4 16.7-37.4 37.4s16.7 37.4 37.4 37.4h110.9v110.9c-0.1 20.7 16.7 37.4 37.4 37.4z" p-id="19180" fill="#ffffff"></path></svg>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="info-container-r">
                    <el-scrollbar class="vl-container" v-if="itemLevel===1||!itemList||itemList.length===0">
                        <div class="video-box">
                            <div class="video-item" v-for="item in videoList">
                                <div class="item-p1">
                                    <div class="video-cover">

                                        <img alt="" :src="item.coverUrl" class="v-img">
                                    </div>
                                    <div class="video-name">
                                        {{item.title}}
                                    </div>
                                </div>
                                <div class="item-p2">
                                    <div class="player-container">
                                        <div class="player-container">
                                            <img alt="" @click="viewVideo(item)" class="img-100" src="../../assets/icon/img/player.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="div-100" v-if="videoList&&videoList.length===0">
                            <dataEmpty title="暂无视频" />
                        </div>
                    </el-scrollbar>

                    <el-scrollbar class="vl-container" v-if="itemLevel===2&&itemList&&itemList.length>0">
                        <div class="classify-container" v-for="item1 in itemList">
                            <!-- 第一层-->
                            <div class="item-level1-container">
                                <div class="item-level1-title">
                                    {{item1.itemName}}
                                    <svg t="1761023200714" @click="videoManager(item1.itemId,null,null,item1.itemId,item1.videoList)" v-if="!item1.children||item1.children.length===0" style="margin-left: 8px;vertical-align: middle;margin-top: -4px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20601" width="20" height="20"><path d="M947.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8V256c0-42.496 34.304-76.8 76.8-76.8h870.4c42.496 0 76.8 34.304 76.8 76.8v512c0 42.496-34.304 76.8-76.8 76.8zM76.8 230.4c-14.336 0-25.6 11.264-25.6 25.6v512c0 14.336 11.264 25.6 25.6 25.6h870.4c14.336 0 25.6-11.264 25.6-25.6V256c0-14.336-11.264-25.6-25.6-25.6H76.8z" fill="#ff7f2e" p-id="20602"></path><path d="M179.2 435.2H25.6c-14.336 0-25.6-11.264-25.6-25.6V256c0-42.496 34.304-76.8 76.8-76.8h102.4c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6zM51.2 384h102.4V230.4H76.8c-14.336 0-25.6 11.264-25.6 25.6v128z" fill="#ff7f2e" p-id="20603"></path><path d="M179.2 640H25.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2H51.2v153.6z" fill="#ff7f2e" p-id="20604"></path><path d="M179.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8v-153.6c0-14.336 11.776-25.6 25.6-25.6h153.6c14.336 0 25.6 11.776 25.6 25.6v204.8c0 13.824-11.776 25.6-25.6 25.6z m-128-204.8v128c0 14.336 11.264 25.6 25.6 25.6h76.8v-153.6H51.2zM947.2 844.8h-102.4c-14.336 0-25.6-11.264-25.6-25.6v-204.8c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v153.6c0 42.496-34.304 76.8-76.8 76.8z m-76.8-51.2h76.8c14.336 0 25.6-11.264 25.6-25.6v-128h-102.4v153.6z" fill="#ff7f2e" p-id="20605"></path><path d="M998.4 640h-153.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2h-102.4v153.6z" fill="#ff7f2e" p-id="20606"></path><path d="M998.4 435.2h-153.6c-14.336 0-25.6-11.776-25.6-25.6V204.8c0-14.336 11.776-25.6 25.6-25.6h102.4c42.496 0 76.8 34.304 76.8 76.8v153.6c0 13.824-11.776 25.6-25.6 25.6z m-128-51.2h102.4V256c0-14.336-11.264-25.6-25.6-25.6h-76.8v153.6zM421.888 671.744c-8.704 0-17.408-2.048-25.6-6.656-15.872-9.216-25.6-26.112-25.6-44.544V403.968c0-18.432 10.24-35.328 26.112-44.544 15.872-9.216 35.84-8.704 51.712 0.512L629.76 468.992c15.36 9.728 24.064 26.624 23.552 44.544-0.512 17.408-9.728 33.28-24.576 41.984l-180.224 108.544c-8.704 5.12-17.92 7.68-26.624 7.68z m0-268.288v216.576l180.224-108.032-180.224-108.544z m180.224 109.056z m0.512-0.512z" fill="#ff7f2e" p-id="20607"></path></svg>
                                </div>
                                <!-- 第一层视频显示-->
                                <div class="div-100" v-if="(!item1.children||item1.children.length===0)&&(!item1.videoList||item1.videoList.length===0)">
                                    <dataEmpty title="暂无视频" />
                                </div>
                                <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item1.children||item1.children.length===0)">
                                    <div class="video-item" v-for="v1 in item1.videoList">
                                        <div class="item-p1">
                                            <div class="video-cover">
                                                <img alt="" :src="v1.coverUrl" class="v-img">
                                            </div>
                                            <div class="video-name">
                                                {{v1.title}}
                                            </div>
                                        </div>
                                        <div class="item-p2">
                                            <div class="player-container">
                                                <div class="player-container">
                                                    <img alt="" @click="viewVideo(v1)" class="img-100" src="../../assets/icon/img/player.png">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 第二层-->
                            <div class="item-level2-container" v-if="item1.children&&item1.children.length>0"
                                 v-for="item2 in item1.children">
                                <div class="item-level2-title">
                                    {{item2.itemName}}
                                    <svg t="1761023200714" @click="videoManager(item1.itemId,item2.itemId,null,item2.itemId,item2.videoList)" v-if="!item2.children||item2.children.length===0" style="margin-left: 8px;vertical-align: middle;margin-top: -4px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20601" width="20" height="20"><path d="M947.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8V256c0-42.496 34.304-76.8 76.8-76.8h870.4c42.496 0 76.8 34.304 76.8 76.8v512c0 42.496-34.304 76.8-76.8 76.8zM76.8 230.4c-14.336 0-25.6 11.264-25.6 25.6v512c0 14.336 11.264 25.6 25.6 25.6h870.4c14.336 0 25.6-11.264 25.6-25.6V256c0-14.336-11.264-25.6-25.6-25.6H76.8z" fill="#ff7f2e" p-id="20602"></path><path d="M179.2 435.2H25.6c-14.336 0-25.6-11.264-25.6-25.6V256c0-42.496 34.304-76.8 76.8-76.8h102.4c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6zM51.2 384h102.4V230.4H76.8c-14.336 0-25.6 11.264-25.6 25.6v128z" fill="#ff7f2e" p-id="20603"></path><path d="M179.2 640H25.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2H51.2v153.6z" fill="#ff7f2e" p-id="20604"></path><path d="M179.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8v-153.6c0-14.336 11.776-25.6 25.6-25.6h153.6c14.336 0 25.6 11.776 25.6 25.6v204.8c0 13.824-11.776 25.6-25.6 25.6z m-128-204.8v128c0 14.336 11.264 25.6 25.6 25.6h76.8v-153.6H51.2zM947.2 844.8h-102.4c-14.336 0-25.6-11.264-25.6-25.6v-204.8c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v153.6c0 42.496-34.304 76.8-76.8 76.8z m-76.8-51.2h76.8c14.336 0 25.6-11.264 25.6-25.6v-128h-102.4v153.6z" fill="#ff7f2e" p-id="20605"></path><path d="M998.4 640h-153.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2h-102.4v153.6z" fill="#ff7f2e" p-id="20606"></path><path d="M998.4 435.2h-153.6c-14.336 0-25.6-11.776-25.6-25.6V204.8c0-14.336 11.776-25.6 25.6-25.6h102.4c42.496 0 76.8 34.304 76.8 76.8v153.6c0 13.824-11.776 25.6-25.6 25.6z m-128-51.2h102.4V256c0-14.336-11.264-25.6-25.6-25.6h-76.8v153.6zM421.888 671.744c-8.704 0-17.408-2.048-25.6-6.656-15.872-9.216-25.6-26.112-25.6-44.544V403.968c0-18.432 10.24-35.328 26.112-44.544 15.872-9.216 35.84-8.704 51.712 0.512L629.76 468.992c15.36 9.728 24.064 26.624 23.552 44.544-0.512 17.408-9.728 33.28-24.576 41.984l-180.224 108.544c-8.704 5.12-17.92 7.68-26.624 7.68z m0-268.288v216.576l180.224-108.032-180.224-108.544z m180.224 109.056z m0.512-0.512z" fill="#ff7f2e" p-id="20607"></path></svg>
                                </div>
                                <!-- 第二层视频显示-->
                                <div class="div-100" v-if="(!item2.children||item2.children.length===0)&&(!item2.videoList||item2.videoList.length===0)">
                                    <dataEmpty title="暂无视频" />
                                </div>
                                <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item2.children||item2.children.length===0)">
                                    <div class="video-item" v-for="v2 in item2.videoList">
                                        <div class="item-p1">
                                            <div class="video-cover">
                                                <img alt="" :src="v2.coverUrl" class="v-img">
                                            </div>
                                            <div class="video-name">
                                                {{v2.title}}
                                            </div>
                                        </div>
                                        <div class="item-p2">
                                            <div class="player-container">
                                                <div class="player-container">
                                                    <img alt="" @click="viewVideo(v2)" class="img-100" src="../../assets/icon/img/player.png">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 第三层-->
                                <div class="item-level3-container" v-if="item2.children&&item2.children.length>0" v-for="item3 in item2.children">
                                    <div class="item-level3-title">
                                        {{item3.itemName}}
                                        <svg t="1761023200714" @click="videoManager(item1.itemId,item2.itemId,item3.itemId,item3.itemId,item3.videoList)" v-if="!item3.children||item3.children.length===0" style="margin-left: 8px;vertical-align: middle;margin-top: -4px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20601" width="20" height="20"><path d="M947.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8V256c0-42.496 34.304-76.8 76.8-76.8h870.4c42.496 0 76.8 34.304 76.8 76.8v512c0 42.496-34.304 76.8-76.8 76.8zM76.8 230.4c-14.336 0-25.6 11.264-25.6 25.6v512c0 14.336 11.264 25.6 25.6 25.6h870.4c14.336 0 25.6-11.264 25.6-25.6V256c0-14.336-11.264-25.6-25.6-25.6H76.8z" fill="#ff7f2e" p-id="20602"></path><path d="M179.2 435.2H25.6c-14.336 0-25.6-11.264-25.6-25.6V256c0-42.496 34.304-76.8 76.8-76.8h102.4c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6zM51.2 384h102.4V230.4H76.8c-14.336 0-25.6 11.264-25.6 25.6v128z" fill="#ff7f2e" p-id="20603"></path><path d="M179.2 640H25.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2H51.2v153.6z" fill="#ff7f2e" p-id="20604"></path><path d="M179.2 844.8H76.8c-42.496 0-76.8-34.304-76.8-76.8v-153.6c0-14.336 11.776-25.6 25.6-25.6h153.6c14.336 0 25.6 11.776 25.6 25.6v204.8c0 13.824-11.776 25.6-25.6 25.6z m-128-204.8v128c0 14.336 11.264 25.6 25.6 25.6h76.8v-153.6H51.2zM947.2 844.8h-102.4c-14.336 0-25.6-11.264-25.6-25.6v-204.8c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v153.6c0 42.496-34.304 76.8-76.8 76.8z m-76.8-51.2h76.8c14.336 0 25.6-11.264 25.6-25.6v-128h-102.4v153.6z" fill="#ff7f2e" p-id="20605"></path><path d="M998.4 640h-153.6c-14.336 0-25.6-11.264-25.6-25.6V409.6c0-14.336 11.264-25.6 25.6-25.6h153.6c14.336 0 25.6 11.264 25.6 25.6v204.8c0 14.336-11.264 25.6-25.6 25.6z m-128-51.2h102.4V435.2h-102.4v153.6z" fill="#ff7f2e" p-id="20606"></path><path d="M998.4 435.2h-153.6c-14.336 0-25.6-11.776-25.6-25.6V204.8c0-14.336 11.776-25.6 25.6-25.6h102.4c42.496 0 76.8 34.304 76.8 76.8v153.6c0 13.824-11.776 25.6-25.6 25.6z m-128-51.2h102.4V256c0-14.336-11.264-25.6-25.6-25.6h-76.8v153.6zM421.888 671.744c-8.704 0-17.408-2.048-25.6-6.656-15.872-9.216-25.6-26.112-25.6-44.544V403.968c0-18.432 10.24-35.328 26.112-44.544 15.872-9.216 35.84-8.704 51.712 0.512L629.76 468.992c15.36 9.728 24.064 26.624 23.552 44.544-0.512 17.408-9.728 33.28-24.576 41.984l-180.224 108.544c-8.704 5.12-17.92 7.68-26.624 7.68z m0-268.288v216.576l180.224-108.032-180.224-108.544z m180.224 109.056z m0.512-0.512z" fill="#ff7f2e" p-id="20607"></path></svg>
                                    </div>
                                    <!-- 第三层视频显示-->
                                    <div class="div-100" v-if="(!item3.children||item3.children.length===0)&&(!item3.videoList||item3.videoList.length===0)">
                                        <dataEmpty title="暂无视频" />
                                    </div>
                                    <div class="video-box" style="margin-top: 5px;margin-bottom: 5px;" v-if="(!item3.children||item3.children.length===0)">
                                        <div class="video-item" v-for="v3 in item3.videoList">
                                            <div class="item-p1">
                                                <div class="video-cover">
                                                    <img alt="" :src="v3.coverUrl" class="v-img">
                                                </div>
                                                <div class="video-name">
                                                    {{v3.title}}
                                                </div>
                                            </div>
                                            <div class="item-p2">
                                                <div class="player-container">
                                                    <div class="player-container">
                                                        <img alt="" @click="viewVideo(3)" class="img-100" src="../../assets/icon/img/player.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>

    <el-dialog width="600px" :title="parClassTitle" v-model="isShowLibraryItem">

        <div  style="display: flex;justify-content: space-between;margin-top: -10px">
            <div style="color: #999;"></div>
            <div class="disnone" style="display: flex;">
                <el-button type="primary" size="small" @click="createdParItem('0')">
                    +&nbsp;新增
                </el-button>
            </div>
        </div>
        <el-tree
          style="width: 500px;margin-top: 10px"
          :data="itemList"
          node-key="itemId"
          default-expand-all
          :expand-on-click-node="false">
            <template #default="{ node, data }">
                <div class="custom-tree-node">
                    <span>{{ data.itemName }}</span>
                    <div>
                        <el-button v-if="data.itemLevel===1||data.itemLevel===2" type="primary" size="small" @click="handleCreateChild(data)">
                            新增
                        </el-button>
                        <el-button style="margin-left: 4px"  type="success" size="small" @click="handleUpdateChild(data)">
                            编辑
                        </el-button>
                        <el-button style="margin-left: 4px" size="small" type="danger" @click="handleDelChild(data)">
                            删除
                        </el-button>
                    </div>
                </div>
            </template>
        </el-tree>
    </el-dialog>

    <el-dialog width="500px" :title="parClassTitle" v-model="isShowEditItem">
        <div>
            <el-form>
                <el-input v-model="itemForm.itemName" placeholder="请输入名称" maxlength="32" />
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitItemForm">
                    确定
                </el-button>
                <el-button @click="isShowEditItem = false">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog width="500px" :title="parClassTitle" v-model="isShowUpdateItem">
        <div>
            <el-form>
                <el-input v-model="updateItemForm.itemName" placeholder="请输入名称" maxlength="32" />
            </el-form>
        </div>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="submitUpdateItemForm">
                    确定
                </el-button>
                <el-button @click="isShowUpdateItem = false">
                    取消
                </el-button>
            </div>
        </template>
    </el-dialog>



    <el-dialog class="ve-dialog" :title="'视频管理'" v-model="isSelVideoShow" top="4vh" width="1035px">
        <div class="sel-video-contain">
            <!--目录-->
            <div class="l-container">
                <div class="l-second-container">
                    <div class="second-box1">
                        <svg t="1755139711785" style="margin-top: 5px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17744" width="16" height="16"><path d="M0 1024V128h256V0h128v128h256V0h128v128h256v896H0zM924.384 227.616H99.616v696.768h824.768V227.616z m-578.048 185.6l125.12 349.152h-83.2l-23.104-71.84H234.496l-23.136 71.84H128l125.12-349.152h93.216z m-1.952 213.696l-44.64-138.336-44.608 138.336h89.248z m235.648 66.048h106.496v69.408H512V413.12h68.032v279.744z m192 0h106.528v69.408H704V413.12h68.032v279.744z" fill="#ff7f2e" p-id="17745"></path></svg>
                    </div>
                    <div class="second-box2 cursor" @click="handleAllVideo">所有视频</div>
                    <div class="second-box3 cursor" @click="handleAllVideo">{{categoryTreeData.videoNum}}</div>
                </div>
                <el-scrollbar class="l-tree-container">
                    <el-tree
                      :data="categoryList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ node, data }">
                            <div class="custom-tree-node" :title="charConversion(data.categoryName)">
                                <span>
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </span>
                                <div>
                                    <el-button type="primary" style="color: #606266;margin-left: 5px;" link>{{data.videoNum}}</el-button>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <div class="r-container">
                <div class="form-box">
                    <el-row style="height: 40px!important;">
                        <el-col :span="24">
                            <el-form-item>
                                <el-input v-model="queryParams.title" placeholder="请输入视频名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="handleQuery" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-scrollbar class="vl-manager-container"  v-loading="videoLoading">
                    <div class="m-video-box">
                        <div class="m-video-item" v-for="item in humVideoList">
                            <div class="m-item-p1">
                                <div class="m-video-cover">
                                    <img alt="" :src="item.coverUrl" class="img-100">
                                </div>
                                <div :class="selVId&&selVId.includes(item.videoId)?'m-video-name-c':'m-video-name'"  @click="selVideo(item)">
                                    <svg v-if="selVId&&selVId.includes(item.videoId)"  t="1755674519412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9201" width="13" height="13"><path d="M196.923077 0h630.153846a196.923077 196.923077 0 0 1 196.923077 196.923077v630.153846a196.923077 196.923077 0 0 1-196.923077 196.923077H196.923077a196.923077 196.923077 0 0 1-196.923077-196.923077V196.923077a196.923077 196.923077 0 0 1 196.923077-196.923077z m0 78.769231a118.153846 118.153846 0 0 0-118.153846 118.153846v630.153846a118.153846 118.153846 0 0 0 118.153846 118.153846h630.153846a118.153846 118.153846 0 0 0 118.153846-118.153846V196.923077a118.153846 118.153846 0 0 0-118.153846-118.153846H196.923077z m584.900923 258.205538a36.509538 36.509538 0 0 1 1.260308 51.633231l-299.480616 313.107692c-0.118154 0.157538-0.393846 0.236308-0.630154 0.472616l-0.393846 0.551384c-2.166154 2.126769-4.726154 3.229538-7.207384 4.726154-1.575385 0.866462-2.796308 2.166154-4.411077 2.835692a35.800615 35.800615 0 0 1-27.490462 0.07877c-1.260308-0.512-2.284308-1.614769-3.544615-2.284308-2.756923-1.457231-5.592615-2.835692-8.034462-5.12-0.196923-0.157538-0.275692-0.433231-0.512-0.669538-0.196923-0.118154-0.393846-0.196923-0.551384-0.354462l-150.843077-156.593231a36.430769 36.430769 0 0 1 0.945231-51.633231 36.391385 36.391385 0 0 1 51.63323 0.945231l124.455385 129.102769 273.092923-285.61723a36.548923 36.548923 0 0 1 51.712-1.181539z" p-id="9202" fill="#ff7f2e"></path></svg>
                                    <svg v-if="!(selVId&&selVId.includes(item.videoId))"  t="1755674519412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9201" width="13" height="13"><path d="M196.923077 0h630.153846a196.923077 196.923077 0 0 1 196.923077 196.923077v630.153846a196.923077 196.923077 0 0 1-196.923077 196.923077H196.923077a196.923077 196.923077 0 0 1-196.923077-196.923077V196.923077a196.923077 196.923077 0 0 1 196.923077-196.923077z m0 78.769231a118.153846 118.153846 0 0 0-118.153846 118.153846v630.153846a118.153846 118.153846 0 0 0 118.153846 118.153846h630.153846a118.153846 118.153846 0 0 0 118.153846-118.153846V196.923077a118.153846 118.153846 0 0 0-118.153846-118.153846H196.923077z m584.900923 258.205538a36.509538 36.509538 0 0 1 1.260308 51.633231l-299.480616 313.107692c-0.118154 0.157538-0.393846 0.236308-0.630154 0.472616l-0.393846 0.551384c-2.166154 2.126769-4.726154 3.229538-7.207384 4.726154-1.575385 0.866462-2.796308 2.166154-4.411077 2.835692a35.800615 35.800615 0 0 1-27.490462 0.07877c-1.260308-0.512-2.284308-1.614769-3.544615-2.284308-2.756923-1.457231-5.592615-2.835692-8.034462-5.12-0.196923-0.157538-0.275692-0.433231-0.512-0.669538-0.196923-0.118154-0.393846-0.196923-0.551384-0.354462l-150.843077-156.593231a36.430769 36.430769 0 0 1 0.945231-51.633231 36.391385 36.391385 0 0 1 51.63323 0.945231l124.455385 129.102769 273.092923-285.61723a36.548923 36.548923 0 0 1 51.712-1.181539z" p-id="9202" fill="#b1b1b1"></path></svg>
                                    {{item.title}}
                                </div>
                            </div>
                            <div class="m-item-p2">
                                <div class="m-player-container">
                                    <div class="m-player-container">
                                        <img alt="" @click="viewVideo(item)" class="img-100" src="../../assets/icon/img/player.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-scrollbar>
            </div>
            <div class="t-container">
                <div class="l-second-container">
                    <div class="second-box1">
                        <svg t="1761039612094" style="margin-top: -3px;vertical-align: middle;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="47472" width="20" height="20"><path d="M806.062 130.314H216.238c-48.181 0-87.381 39.2-87.381 87.381v589.824c0 48.181 39.2 87.381 87.381 87.381h589.824c48.181 0 87.381-39.2 87.381-87.381V217.695c0-48.181-39.2-87.381-87.381-87.381z m-62.623 243.818L463.212 654.359c-11.286 11.286-29.855 11.286-41.142 0L278.861 511.15c-11.286-11.286-11.286-29.855 0-41.142s29.855-11.286 41.142 0l122.576 122.576 259.596-259.596c11.286-11.286 29.855-11.286 41.142 0 11.53 11.286 11.53 29.733 0.122 41.142z" fill="#ff7f2e" p-id="47473"></path></svg>
                    </div>
                    <div class="second-box2 cursor">已选视频</div>
                    <div class="second-box3 cursor">{{vNum}}</div>
                </div>
                <el-scrollbar class="r-tree-container">
                    <div class="video-card" v-for="(item,index) in itemVideoList" :key="index"
                         @mouseover="showOperate(index)"
                         @mouseout="hideOperate">
                        <span style="color: #ff7f2e;font-weight: bold">{{index+1}}.</span>
                        {{item.title}}
                        <div v-show="operateIndex === index" class="operate-container">
                            <div class="operate-btn" @click="moveTopVideo(index)">置顶</div>
                            <div class="operate-btn" @click="moveBottomVideo(index)">置底</div>
                            <div class="operate-btn" @click="moveUpVideo(index)">上移</div>
                            <div class="operate-btn" @click="moveDownVideo(index)">下移</div>
                            <div class="operate-btn-last" @click="delVideo(item,index)">删除</div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <div class="sel-info-contain">
            <div class="info-item1">已选中<span style="color: #ff7f2e;font-weight: bold">{{vNum}}</span>条视频</div>
            <div class="info-item2"> <el-button @click="isSelVideoShow = !isSelVideoShow">取 消</el-button></div>
            <div class="info-item3"><el-button type="primary" @click="submitLibraryVideo">确 认</el-button></div>
        </div>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {
    createClassLibraryItem, deleteClassLibraryItem,
    infoBook,
    treeListClassLibraryItem,
    updateClassLibraryItem,
    classLibraryRelationVideo
} from "@/api/admin/classLibrary";
import dataEmpty from "@/components/dataEmpty.vue";
import {listHumanityVideo, treeCategory} from "@/api/admin/humanity";
import {charConversion} from "@/utils/str";

export default {
    name: "subjectFusionInfo",
    components: {dataEmpty},
    data() {
        return {
            serviceUrl,
            isViewVideoShow:false,
            token: this.$storage.get("token"),
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
            itemLevel:3,
            classId:'', // 课本ID
            bookData:{},
            unitList:[],
            videoList:[],
            allVideoList:[],
            unitId:'',  // 单元ID
            chapterId:'',  // 章节ID,
            filterId:'',
            bookItemId:[],
            itemList:[],
            defaultProps: {
                children: 'childrenList',
                label: 'className',
                value:'classId'
            },
            props:{
                multiple: false,
                checkStrictly: true,
                label:'className',
                value:'classId',
                children:'childrenList'
            },
            // 课程结构
            isShowLibraryItem:false,
            isShowEditItem:false,
            isShowUpdateItem:false,
            parClassId:'',
            parClassTitle:'',
            itemForm:{
                parentId:'0',
                classId:'',
                itemName:'',
            },
            updateItemForm:{
                itemId:'',
                itemName:'',
            },
            bookItemList:[],
            // 管理视频
            queryParams:{
                title: '',
                categoryId: '',
                isTag: '',
                isCourse: '',
            },
            vNum:0,
            selVId:'',
            operateIndex:null,
            isSelVideoShow:false,
            videoLoading:false,
            categoryTreeList:{},
            categoryTreeData:{},
            categoryList:[],
            humVideoList:[],
            itemVideoList:[],
            parentItemIds:'',
            itemId:'',
            videoForm:{
                classId: '',
                unitId: '',
                chapterId: '',
                parentItemIds: '',
                itemId: '',
                videoList:[],
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryVideoList();
        this.queryTreeCategory();
    },
    mounted(){
        if (this.$route.query.sign) {
            this.classId = this.$route.query.sign
            this.queryBookInfo()
        }
    },
    methods: {
        charConversion,
        backList(){
            this.$router.push({
                path: "/humanityLibrary",
            });
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        queryBookInfo(){
            infoBook({ classId: this.classId }).then(res => {
                if (res.data.code === 1) {
                    this.bookData = res.data.data;
                    this.unitList = this.bookData.childrenList;
                    this.videoList = this.bookData.videoList;
                    // 去除重复信息
                    if (this.videoList&&this.videoList.length>0){
                        const map = new Map();
                        this.videoList.forEach(item => map.set(item.videoId, item));
                        this.videoList = Array.from(map.values());
                    }
                    this.allVideoList = this.bookData.videoList;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        selUnitItem(uId,iId,list,level){
            this.unitId = uId;
            this.chapterId = iId;
            this.itemList = [];
            if (level===2){
                this.parClassId = iId;
                this.treeListClassLibrary();
            }
            this.itemLevel = level;
            this.filterVideo();
        },
        filterVideo(){
            let list = [];
            if (this.unitId!==''){
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(this.unitId)) {
                        list.push(item);
                    }
                })
            }
            if (this.chapterId!==''){
                list = [];
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(this.chapterId)) {
                        list.push(item);
                    }
                })
            }
            // 去除重复信息
            if (list.length>0){
                const map = new Map();
                list.forEach(item => map.set(item.videoId, item));
                list = Array.from(map.values());
            }
            this.videoList = list;
        },
        filterLevelVideo(itemId){
            return this.allVideoList.filter((item)=>{
                return item.courseInfo.includes(itemId);
            })
        },
        judgeIsVideo(itemId){
            let list = [];
            list = this.allVideoList.filter((item)=>{
                return item.courseInfo.includes(itemId);
            })
            return list && list.length > 0;
        },
        clearItem(){
            this.bookItemId = [];
            this.filterVideo();
        },
        changeItem(){
            if (this.bookItemId&&this.bookItemId.length>0){
                let dataId = this.bookItemId[this.bookItemId.length - 1];
                let list = [];
                this.allVideoList.filter((item)=>{
                    if (item.courseInfo.includes(dataId)) {
                        list.push(item);
                    }
                })
                this.videoList = list;
            }else {
                this.clearItem();
            }

        },
        /*课程结构*/
        handleItem(cId,title){
            this.parClassId = cId;
            this.parClassTitle = title;
            this.isShowLibraryItem = true;
            this.treeListClassLibrary();
        },
        createdParItem(pId){
            this.itemForm.classId = this.parClassId;
            this.itemForm.parentId = pId;
            this.itemForm.itemName = '';
            this.isShowEditItem = true;
        },
        handleCreateChild(data){
            this.itemForm.classId = this.parClassId;
            this.itemForm.parentId = data.itemId;
            this.itemForm.itemName = '';
            this.isShowEditItem = true;
        },
        handleUpdateChild(data){
            this.updateItemForm.itemId = data.itemId;
            this.updateItemForm.itemName = data.itemName;
            this.isShowUpdateItem = true;
        },
        handleDelChild(data){
            deleteClassLibraryItem({itemId:data.itemId}).then(res => {
                if (res.data.code === 1) {
                    this.treeListClassLibrary();
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        submitItemForm(){
            createClassLibraryItem(this.itemForm).then(res => {
                if (res.data.code === 1) {
                    this.treeListClassLibrary();
                    this.isShowEditItem = false;
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        submitUpdateItemForm(){
            updateClassLibraryItem(this.updateItemForm).then(res => {
                if (res.data.code === 1) {
                    this.treeListClassLibrary();
                    this.isShowUpdateItem = false;
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        treeListClassLibrary(){
            treeListClassLibraryItem({classId:this.parClassId}).then(res => {
                if (res.data.code === 1) {
                    this.itemList =  res.data.data;
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        // 视频管理
        queryVideoList(){
            this.videoLoading = true;
            listHumanityVideo(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.humVideoList = res.data.data;
                    this.videoLoading = false;
                } else {
                    this.$message.error("请求出错");
                    this.videoLoading = false;
                }
            })
        },
        queryTreeCategory(){
            treeCategory().then(res => {
                if (res.data.code===1){
                    if (res.data.data){
                        this.categoryTreeList= res.data.data;
                        this.categoryTreeData = this.categoryTreeList[0];
                        this.categoryList = this.categoryTreeData.children;
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        videoManager(itemId1,itemId2,itemId3,itemId,vList){
            this.vNum = 0;
            this.itemId = '';
            this.parentItemIds = '';
            this.itemVideoList = [];
            if (itemId1){
                this.parentItemIds =itemId1;
            }
            if (itemId2){
                this.parentItemIds =this.parentItemIds+','+itemId2;
            }
            if (itemId3){
                this.parentItemIds =this.parentItemIds+','+itemId3;
            }
            this.itemId = itemId;
            this.selVId = '';
            if (vList&&vList.length>0){
                vList.forEach(i  =>{
                    this.selVId = this.selVId+i.videoId+','
                })
                this.itemVideoList = vList;
                this.vNum = vList.length;
            }
            this.isSelVideoShow = true;
        },
        handleAllVideo(){
            this.queryParams.categoryId='';
            this.queryVideoList();
        },
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryVideoList();
        },
        handleQuery(){
            this.queryVideoList();
        },
        selVideo(item){
            // 添加
            if (!this.selVId.includes(item.videoId)){
                this.selVId = this.selVId+item.videoId+",";
                this.handleListAddVideo(item)
            }else {
                this.selVId = this.selVId.replace(item.videoId+",", '');
                this.handleListDelVideo(item)
            }
        },
        handleListAddVideo(item){
            this.itemVideoList.push(item)
            this.vNum = this.itemVideoList.length;
        },
        handleListDelVideo(item){
            this.itemVideoList = this.itemVideoList.filter(v => v.videoId !== item.videoId);
            this.vNum = this.itemVideoList.length;
        },
        delVideo(item,num){
            this.vNo = num;
            this.handleListDelVideo(item);
            this.selVideo(item);
        },
        moveTopVideo(index){
            if (index !== 0) {
                this.itemVideoList.unshift(this.itemVideoList.splice(index, 1)[0]);
            }else {
                this.$message.warning('该视频已在首位')
            }

        },
        moveBottomVideo(index){
            if (index !== this.itemVideoList.length - 1) {
                this.itemVideoList.push(this.itemVideoList.splice(index, 1)[0]);
            }else {
                this.$message.warning('该视频已在末位')
            }
        },
        moveUpVideo(index){
            if (index !== 0) {
                this.itemVideoList[index] = this.itemVideoList.splice(index - 1, 1, this.itemVideoList[index])[0];
            } else {
                this.$message.warning('该视频已在首位')
            }
        },
        moveDownVideo(index){
            if (index !== this.itemVideoList.length - 1) {
                this.itemVideoList[index] = this.itemVideoList.splice(index + 1, 1, this.itemVideoList[index])[0];
            } else {
                this.$message.warning('该视频已在末位')
            }
        },
        showOperate(index){
            this.operateIndex = index
        },
        hideOperate(){
            this.operateIndex = null
        },
        submitLibraryVideo(){
            this.videoForm.classId = this.classId;
            this.videoForm.unitId = this.unitId;
            this.videoForm.chapterId = this.chapterId;
            this.videoForm.parentItemIds = this.parentItemIds;
            this.videoForm.itemId = this.itemId;
            this.videoForm.videoList = this.itemVideoList;
            classLibraryRelationVideo(this.videoForm).then(res => {
                if (res.data.code === 1) {
                    this.treeListClassLibrary();
                    this.isSelVideoShow = false;
                }else {
                    this.$message.error('操作失败')
                }
            })
        },
    }
}

</script>

<style scoped>
.base-create-container{
    width: 100%;
    height: calc(100vh - 85px);
    background-color: #fff;
    overflow-y: auto!important;
    box-sizing: border-box;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    border-top: 1px solid #f1f1f1;
}
.info-container-l{
    width: 260px;
    height: 100%;
    padding: 5px 0 5px 10px;
    box-sizing: border-box;
    border-right: 1px solid #f1f1f1;
}
.scrollbar-container{
    width: 100%;
}
.unit-container{
    width: 100%;
    height: auto;
}
.unit-container-title{
    font-size: 16px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #121212;
    cursor: pointer;
    padding-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-container-title-active{
    font-size: 15px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #ff7f2e;
    cursor: pointer;
    padding-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-item-container{
    width: 100%;
    height: auto;
    //flex-wrap: wrap!important;
    //display: flex;
}
.unit-item{
    font-size: 15px;
    height: auto;
    line-height: 22px;
    color: #6a6a6a;
    //border: 1px solid #ebebeb;
    background-color: #fff;
    cursor: pointer;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    text-indent: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.unit-item-active{
    font-size: 16px;
    height: auto;
    line-height: 22px;
    color: #fff;
    border: 1px solid #ff7f2e;
    background-color: #ff7f2e;
    cursor: pointer;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    text-indent: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.info-container-r{
    width: calc(100% - 260px);
    height: 100%;
    padding: 10px 0 5px 10px;
    box-sizing: border-box;
}
.vl-container{
    width: 100%;
    height: 100%;
}
.video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.video-item{
    width: 25%;
    height: 170px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -165px;
    padding-top: 30px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 120px;
    background-color: #dcdfe6;
}
.video-name{
    width: 100%;
    height: 42px;
    line-height: 16px;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #6a6a6a;
    padding-top: 5px;
}
.v-img{
    width: 100%;
    height: 100%;
}

/*课程层级目录*/
.classify-container{
    width: 100%;
    height: auto;
}
.item-level1-title{
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #121212;
    font-family: sans-serif;
}
.item-level2-title{
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    height: 24px;
    line-height: 24px;
    color: #121212;
    font-family: sans-serif;
    text-indent: 15px;
}
.item-level3-title{
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    height: 24px;
    line-height: 24px;
    color: #121212;
    font-family: sans-serif;
    text-indent: 30px;
}
/*课程结构*/
.custom-tree-node{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;
}
/*视频管理*/
.sel-video-contain{
    width: 1000px;
    height: 75vh;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
}
.sel-info-contain{
    width: 1000px;
    padding-top: 10px;
    height: 40px;
    display: flex;
}
.info-item1{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-family: sans-serif;

}
.info-item2{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
}
.info-item3{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
    margin-left: 20px;
}
.l-container{
    width: 230px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    border-right: 1px solid #dcdfe6;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 0;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.form-box{
    padding-top: 10px;
}
.r-container{
    width: calc(100% - 460px);
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.vl-manager-container{
    width: 100%;
    height: calc(100% - 60px);
}
.m-video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.m-video-item{
    width: 33%;
    height: 145px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.m-item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.m-item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -145px;
    padding-top: 30px;
    box-sizing: border-box;
}
.m-player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.m-video-cover{
    width: 100%;
    height: 100px;
}
.m-video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #b1b1b1;
    padding-top: 5px;
}
.m-video-name-c{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #ff7f2e;
    padding-top: 5px;
}
.v-list-container{
    width: 100%;
    height: auto;
    padding: 10px 10px 10px 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.v-list-item{
    width: 15%;
    height: 120px;
    padding: 0 10px 10px 10px;
    cursor: pointer;
}
.v-t{
    width: 100%;
    height: 30px;
    display: flex;
    padding-top: 5px;
}
.v-t-l{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    color: #121212;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.v-t-r{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.t-container{
    width: 230px;
    height: 100%;
    padding-left: 5px;
    background-color: #fff;
    border-radius: 4px;
    border-left: 1px solid #dcdfe6;
    box-sizing: border-box;
}
.r-tree-container{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 0 0 0;
    box-sizing: border-box;

}
.video-card{
    width: 98%;
    height: auto;
    margin: 0 auto 10px auto;
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 5px;
    box-sizing: border-box;

}
.operate-container{
    width: 100%;
    height: 25px;
    padding: 5px 0 0 0;
    box-sizing: border-box;
    display: flex;
}
.operate-btn{
    width: calc(20% - 4px);
    margin-right: 5px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
}
.operate-btn-last{
    width: calc(20% - 4px);
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    font-size: 11px;
}
</style>